export const getAssistantEvents = (prefix: string) => ({
    events: {
        PROCESS_STARTED: "Generating response",
        PROCESS_ENDED: "Generated response",
        PROCESS_ERROR: "Error generating response",
        PROCESS_RESPONSE_VALIDATION: "Validating assistant response",
        PROCESS_RESPONSE_VALIDATION_ERROR:
            "Error validating assistant response",
        PROCESS_RESPONSE_VALIDATION_SUCCESS:
            "Assistant response validation successful",
        PROCESS_RESPONSE_RETRY: "Retrying assistant response",
        ASSISTANT_FLOW_ENDED: "Assistant flow has ended",
    },
    name: prefix + "_ASSISTANT",
});

export const TABLE_ASSISTANT = "TABLE";
